// Worker views return English `errorMessage` strings for various failure
// conditions. Map
// known canonical strings back to i18n keys so the UI shows localized text.
// Unknown errors fall through to the original English string.

import i18n from "./i18n.ts";

const LEGACY_ERROR_TO_KEY: Record<string, string> = {
	"Player not found.": "errorMessage.playerNotFound",
	"Invalid team ID.": "errorMessage.invalidTeamId",
};

export const translateErrorMessage = (englishMessage: string): string => {
	if (!i18n.isInitialized) return englishMessage;
	const key = LEGACY_ERROR_TO_KEY[englishMessage];
	if (key) {
		const t = i18n.t(key, { ns: "ui", defaultValue: englishMessage });
		return typeof t === "string" && t.length > 0 ? t : englishMessage;
	}
	return englishMessage;
};
